import { clearKitchenSyncQueue } from '@/shared/sync/kitchenSyncQueue'

const STORAGE_KEY = 'superoti.delman.device'

export type DelmanDeviceBinding = {
  deviceId: string
  deviceUid: string
  deviceName: string
  delmanId: string
  delmanName: string
  kitchenId: string
  kitchenName: string
  deviceType: 'delman_mobile'
  activatedAt: string
}

export function getDelmanDevice(): DelmanDeviceBinding | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw) as DelmanDeviceBinding
  } catch {
    return null
  }
}

// Antrean sinkron berisi PIN/foto milik binding tertentu; tidak boleh terkirim
// memakai token binding lain setelah HP diaktivasi ulang atau di-unbind.
export function setDelmanDevice(binding: DelmanDeviceBinding): void {
  if (getDelmanDevice()?.deviceId !== binding.deviceId) clearKitchenSyncQueue()
  localStorage.setItem(STORAGE_KEY, JSON.stringify(binding))
}

export function clearDelmanDevice(): void {
  clearKitchenSyncQueue()
  localStorage.removeItem(STORAGE_KEY)
}

export function hasDelmanDevice(): boolean {
  return getDelmanDevice() !== null
}
